import {
  Button,
  Dialog,
  Grid,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { forwardRef } from "react";
import CustomTextField from "../../../../CustomComponents/CustomTextField";


const Transition = forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => {
  const appbarHeight = 70;
  return {
    root: { top: `${appbarHeight}px !important`, color: "blue" },
  };
});

const BusinessIncomeAssesLocDialog = ({ businessLocOpen, setBusinessLocOpen, locationList}) => {
  const classes = useStyles();

  return (
    <>
      <Dialog
        fullScreen
        open={businessLocOpen}
        TransitionComponent={Transition}
        className={classes.root}
      >
        <Toolbar>
          <Typography
            sx={{
              ml: 2,
              flex: 1,
            }}
          >
            <h4>Location Details</h4>
          </Typography>
            <Button variant="contained" 
              onClick={() => setBusinessLocOpen(false)}
            >
              Close
            </Button>
        </Toolbar>
        <Box
          sx={{
            marginBottom: "8px",
            marginLeft: "40px",
            marginRight: "24px",
            justifyContent: "center",
          }}
        >
       <Grid container rowSpacing={0} columnSpacing={2}>
         <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Location ID"
               variant="standard"
               placeholder="Enter Location ID"
               disabled={true}
               value={locationList.locationId}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Internal Application ID"
               variant="standard"
               placeholder="Enter Internal Application ID"
               disabled={true}
               value={locationList.internalApplicationId}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Selected Internal Customer Ids"
               variant="standard"
               placeholder="Enter Selected Internal Customer Ids"
               disabled={true}
               value={locationList.selectedInternalCustomerIds}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Business Assessment ID"
               variant="standard"
               placeholder="Enter Business Assessment ID"
               disabled={true}
               value={locationList.businessAssessmentId}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Assessed Role"
               variant="standard"
               placeholder="Enter Assessed Role"
               disabled={true}
               value={locationList.assessedRole}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Assessed (Or) Documented"
               variant="standard"
               placeholder="Enter Is Assessed (Or) Documented"
               disabled={true}
               value={locationList.isAssessedOrDocumented}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Bank Statement"
               variant="standard"
               placeholder="Enter Is Bank Statement"
               disabled={true}
               value={locationList.isBankStatement}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is GST Filings"
               variant="standard"
               placeholder="Enter Is GST Filings"
               disabled={true}
               value={locationList.isGstFilings}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is ITR Filings"
               variant="standard"
               placeholder="Enter Is ITR Filings"
               disabled={true}
               value={locationList.isItrFilings}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Address"
               variant="standard"
               placeholder="Enter Address"
               disabled={true}
               value={locationList.address}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
               type="text"
               label="Coordinates"
               variant="standard"
               placeholder="Enter Coordinates"
               disabled={true}
               value={locationList.coordinates}
              />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
               type="text"
               label="Template"
               variant="standard"
               placeholder="Enter Template"
               disabled={true}
               value={locationList.template}
              />
             </Grid>
             </Grid>
          </Box>
      </Dialog>
    </>
  );
};
export default BusinessIncomeAssesLocDialog;
